module.exports = "<span>{{user.name.charAt(0) | uppercase }}</span>\n"